import { render, staticRenderFns } from "./CompDelete.vue?vue&type=template&id=1acad8b0&scoped=true&"
import script from "./CompDelete.vue?vue&type=script&lang=js&"
export * from "./CompDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acad8b0",
  null
  
)

export default component.exports